<template>
    <purchase-sector>
        <div class="mx-auto" style="max-width:480px">
            <v-row class="ma-n1">
                <v-col class="pa-1">
                    <v-btn x-large block v-bind="{ loading }" @click="exit"> 취소하기 </v-btn>
                </v-col>
                <v-col class="pa-1">
                    <v-btn x-large block color="primary" v-bind="{ loading }" @click="post"> 결제하기 </v-btn>
                </v-col>
            </v-row>
        </div>
    </purchase-sector>
</template>

<script>
import PurchaseSector from "./purchase-sector.vue";

/** @typedef {import('@/store/nshop').NshopOrder} $NshopOrder */

export default {
    components: {
        PurchaseSector,
    },
    props: {
        /** @type {import('vue').PropType<$NshopOrder>} */
        value: { type: Object, default: () => ({}) },
        loading: { type: Boolean, default: false },
    },
    data: () => ({}),
    methods: {
        exit() {
            this.$router.push("/");
        },
        post() {
            this.$emit("post");
        },
    },
};
</script>

<style></style>
